/**
 * Get roommates value object from editor element (roommate_1..4).
 */
export function getRoommatesValue(editorElement) {
  const inputs = editorElement.querySelectorAll('.js-showing-view-roommate-input');
  const keys = ['roommate_1', 'roommate_2', 'roommate_3', 'roommate_4'];
  const value = {};
  keys.forEach((k, i) => {
    value[k] = (inputs[i]?.value ?? '').trim();
  });
  return value;
}

/**
 * Get display string for roommates (comma-separated non-empty values).
 */
export function getRoommatesDisplayValue(editorElement) {
  const value = getRoommatesValue(editorElement);
  const parts = Object.values(value).filter(Boolean);
  return parts.length ? parts.join(', ') : '';
}

/**
 * Set roommates inputs from value object.
 */
export function setRoommatesValue(editorElement, value) {
  const inputs = editorElement.querySelectorAll('.js-showing-view-roommate-input');
  const keys = ['roommate_1', 'roommate_2', 'roommate_3', 'roommate_4'];
  keys.forEach((k, i) => {
    if (inputs[i]) inputs[i].value = value[k] ?? '';
  });
}
